import { createStore } from 'zustand/vanilla';
import { Dimensions } from '@/lib/types/dimensions';

export type LayoutDimensionsState = {
  windowDimensions?: Dimensions;
  navbarDimensions?: Dimensions;
  contentWidth?: number;
};

export type LayoutDimensionsActions = {
  setWindowDimensions: (dimensions: Partial<Dimensions>) => void;
  setNavbarDimensions: (dimensions: Partial<Dimensions>) => void;
  setContentWidth: (width: number) => void;
};

export type LayoutDimensionsStore = LayoutDimensionsState & LayoutDimensionsActions;

const defaultDimensions: Dimensions = { width: 0, height: 0 };
const defaultInitState: LayoutDimensionsState = {};

export const createLayoutDimensionsStore = (
  initState: Partial<LayoutDimensionsState> = defaultInitState,
) => {
  return createStore<LayoutDimensionsStore>()((set) => ({
    ...{ ...defaultInitState, ...initState },
    setContentWidth: (width) => set({ contentWidth: width }),
    setNavbarDimensions: (dims) => set({ navbarDimensions: { ...defaultDimensions, ...dims } }),
    setWindowDimensions: (dims) => set({ windowDimensions: { ...defaultDimensions, ...dims } }),
  }));
};
